import { RouteInfo } from "@tr/models"

// Menu Items
export const superProfileLinks: RouteInfo[] = [
]
// Menu Items
export const superLinks: RouteInfo[] = [
  {
    path: "/super/dashboard",
    title: "Dashboard",
    icon: "ti-panel",
  },
]
